import { fork } from 'redux-saga/effects'

import authSagas from './auth'
import bookingSetupSagas from './bookingSetup'
import searchSagas from './search'
import aliadaSagas from './aliada'
import serviceSagas from './service'
import recurrenceSagas from './recurrence'
import userSagas from './user'

export default function* rootSaga () {
  yield * [
    fork(authSagas),
    fork(bookingSetupSagas),
    fork(searchSagas),
    fork(aliadaSagas),
    fork(serviceSagas),
    fork(recurrenceSagas),
    fork(userSagas)
  ]
}



// WEBPACK FOOTER //
// ./src/redux/sagas/index.js